import '../../Component/components/CaptionComponent';
import ImageComponent from '../../Component/components/ImageComponent';
import SVGComponent from '../../Component/components/SVGComponent';
import TextComponent from '../../Component/components/TextComponent';
import '../../editor.store';
import Delete from './Delete.svelte';
import Duplicate from './Duplicate.svelte';
import ElementMoreOptions from './ElementMoreOptions.svelte';
import HideDelete from './HideDelete.svelte';
import Transparency from './Transparency.svelte';
import Layer from './Layer.svelte';
import ClipComponent from '../../Component/components/ClipComponent';
export default class DefaultModule {
    validComponents = [ImageComponent, TextComponent, SVGComponent, ClipComponent];
    toolbarActions = [
        {
            component: Transparency
        },
        {
            component: Layer
        },
        {
            component: HideDelete
        }
    ];
    elementToolbar = [
        {
            component: Duplicate
        },
        {
            component: Delete
        },
        {
            component: ElementMoreOptions
        }
    ];
}
